// Storage keys used across the application
// LocalStorage keys
export const REACT_STORAGE_AUTH_KEY = 'HONEYBOOK_REACT_CURR_USER';
export const HB_USER_DETAILS = 'ngStorage-hb_user_details';
// jStorage keys (HB_ prefix). The names came from the Angular app; stored sessions use them,
// so renaming a key logs existing users out.
export const jStorageKeys = {
    CURR_USER: 'HB_CURR_USER',
    API_VERSION: 'HB_API_VERSION',
    AUTH_TOKEN: 'HB_AUTH_TOKEN',
    AUTH_USER_ID: 'HB_AUTH_USER_ID',
    TRUSTED_DEVICE: 'HB_TRUSTED_DEVICE'
};
export const sessionStorageKeys = {
    PARTNER_WELCOME_MODAL_DISPLAY: 'hb_partner_welcome_modal_display',
    HOME_MODAL_DISPLAY: 'home_modal_display',
    COUPON: 'HB_COUPON',
    HB_SUBSCRIPTION_COUPON: 'hb_subscription_coupon'
};
//# sourceMappingURL=storage-constants.js.map